import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';

const OPERATOR_OPTIONS = [
    { value: 'ADD', imagePath: '/images/block/arithmetic_add.svg', tooltip: '足し算 [+]' },
    { value: 'SUB', imagePath: '/images/block/arithmetic_sub.svg', tooltip: '引き算 [-]' },
    { value: 'MUL', imagePath: '/images/block/arithmetic_mul.svg', tooltip: '掛け算 [*]' },
    { value: 'DIV', imagePath: '/images/block/arithmetic_div.svg', tooltip: '割り算 [/]' },
    { value: 'MOD', imagePath: '/images/block/arithmetic_mod.svg', tooltip: '余り [%]' },
];

defineBlock({
    type: 'arithmetic',
    colour: CATEGORIES.operator.color,
    tooltip: '2つの値を計算します',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Number',
    inputs: [
        {
            kind: 'value',
            name: 'A',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'OP',
                    instance: () => new FieldOperatorDropdown(OPERATOR_OPTIONS),
                },
            ],
        },
        {
            kind: 'value',
            name: 'B',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
    ],
});
